/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const GET_MEMBERSHIP_STATS = 'GET_MEMBERSHIP_STATS';
export const OPEN_RENEWAL_CYCLE = 'OPEN_RENEWAL_CYCLE';
export const CLOSE_RENEWAL_CYCLE = 'CLOSE_RENEWAL_CYCLE';
export const TRIGGER_REMINDER_RENEWAL_CYCLE = 'TRIGGER_REMINDER_RENEWAL_CYCLE';
